var React = require('react');

function IconDoubleQuotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#F54B26","strokeWidth":"2","d":"M33.2,41.1c0,7.6-6.5,13.9-15.5,13.9C6.9,55,1,46,1,36.7C1,11.8,18.6,2.9,30.5,2v12.3\n\tc-6.3,0.7-14.8,5.6-15.3,13.9c0.4-0.2,2.2-0.9,4-0.9C28.2,27.3,33.2,33.1,33.2,41.1z M71,41.1C71,48.7,64.5,55,55.5,55\n\tC44.7,55,39,46,39,36.7C39,11.8,56.4,2.9,68.3,2v12.3C62,15,53.5,19.9,53,28.2c0.4-0.2,2.2-0.9,4-0.9C66,27.3,71,33.1,71,41.1z"}));
}

IconDoubleQuotes.defaultProps = {"width":"72px","height":"56px","viewBox":"0 0 72 56"};

module.exports = IconDoubleQuotes;

IconDoubleQuotes.default = IconDoubleQuotes;
